import { InfoCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import TcMap from 'components/UI/Map/TcMap';
import ShowLocationMap from 'components/UI/Map/showLocationModal/ShowLocationMap';
import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import endpointUrls from 'global/Constants/endpointUrls';
import { podoPinIcon } from 'global/Constants/leafletIcons';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { inqueryKiosk, inqueryLocker, pudoBranch, userAccessibleLKiosk } from 'global/Models/lockerModel';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import OmParcelOrderModel from 'global/Models/omParcelOrderModel';
import { handleApiThen, handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface Props {
  loading?: boolean;
  cityId?: number;
  packages: packageCreate[] | undefined;
  index: number;
  userAccessibleKiosksList?: IBackendGetGeneric<userAccessibleLKiosk>;
  setLockerAddress?: (_locker: lockerInfo) => void;
  pudoBranchesList?: pudoBranch[];
  handleClose?: () => void;
}

const OrderSelectLockerListOnMapTab: FC<Props> = ({ userAccessibleKiosksList, pudoBranchesList, cityId, packages, index, setLockerAddress, handleClose }) => {
  //states
  const [showMap, setShowMap] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const omOrderReservedByLocker = useSelector((state: RootState) => state.parcelOrder.omOrderReservedByLocker);
  const [inqueryKioskloading, setInqueryKioskloading] = useState<boolean>(false);
  //hook

  //effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMap(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [cityId]);

  //function
  const reserveLocker = async (locker: inqueryLocker): Promise<boolean> => {
    if (!cityId) return false;
    if (!packages) return false;
    await ApiService.post(endpointUrls.lockerInsertOrder, {
      lockerId: locker.id,
      sourceCityId: packages[0].sourceCity?.id,
      destinationCityId: packages[0].destinationCity?.id,
    }).then((res: any) => {
      handleApiThen({
        res,
        onSuccess: () => {
          setLockerAddress &&
            setLockerAddress({
              orderNumber: res.data?.order?.orderNumber,
              locker,
              cityId,
            });

          handleClose && handleClose();
        },
        notifFail: true,
        notifSuccess: true,
      });
    });

    return true;
  };

  const callReservationForEachLocker = async (lockersList: inqueryLocker[]) => {
    setLoading(true);

    for (let i = 0; i < lockersList.length; i++) {
      const locker = lockersList[i];
      const isSuccess = await reserveLocker(locker);
      if (isSuccess) {
        setLoading(false);
        break;
      }

      if (i === lockersList.length - 1) {
        message.error('تمام قفسه های این کیوسک قبلا رزرو شده است. لطفا چند لحظه دیگر امتحان کنید.');
        setLoading(false);
      }
    }
  };

  const callInquiryKioskForGettingEmptyLockers = async (bunchId: number) => {
    if (!packages) return;
    setInqueryKioskloading(true);
    const pack = packages ? packages[index] : ({} as packageCreate);
    // How It Works:
    // The code iterates over each package in the pack array, creating objects with dimensions and weight. If count is 1, a single object is added; otherwise, multiple objects are added based on count.
    const payload = {
      dimensions: pack.package.flatMap((pkg) => {
        const { width, height, length, weight, count } = pkg;
        if (!count || count < 2) {
          return [{ width, height, length, weight }];
        } else {
          return Array.from({ length: count }, () => ({ width, height, length, weight }));
        }
      }),
    };
    await ApiService.post(endpointUrls.lockerInqueryBunch, {
      sourceCityId: packages[index].sourceCity?.id,
      destinationCityId: packages[index].destinationCity?.id,
      bunchId,
      ...payload,
    })
      .then((res: IBackendGetGeneric<inqueryKiosk>) =>
        handleApiThenGeneric<IBackendGetGeneric<inqueryKiosk>, inqueryKiosk>({
          res,
          onSuccessData: (data) => {
            callReservationForEachLocker(data.lockers);
          },
          notifFail: true,
          notifSuccess: false,
          // onFailed: () => message.error('خطا در دریافت لیست لاکرهای این کیوسک'),
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setInqueryKioskloading(false);
  };

  const handleSelectPudo = (pudo: pudoBranch) => {
    if (!cityId) return;
    setLockerAddress &&
      setLockerAddress({
        orderNumber: '',
        locker: {} as inqueryLocker,
        cityId,
        pudoId: pudo.id,
      });

    handleClose && handleClose();
  };

  //constant
  const kioskList = userAccessibleKiosksList?.data.bunches;

  return (
    <>
      {showMap && !omOrderReservedByLocker && (
        <>
          <div className='flex items-center pb-1 font-medium'>
            <InfoCircleOutlined className='ml-1 text-base animate-pulse inherit-color text-t-error-color' />
            با انتخاب کیوسک مدنظر روی نقشه امکان رزرو کیوسک برای شما فعال می شود.
          </div>
          <TcMap zoomLevel={12} customHeight=' h-[65vh] '>
            {kioskList?.map(({ id, lat, lon, address }) => (
              <ShowLocationMap
                key={id}
                location={{ lat, lng: lon }}
                popupMarker={OmParcelOrderModel.PopupMarkerContent(loading, inqueryKioskloading, callInquiryKioskForGettingEmptyLockers, { address, lat, lng: lon, id })}
              />
            ))}
            {pudoBranchesList?.map((pudo) => (
              <ShowLocationMap
                key={`pudo-${pudo.id}`}
                location={{ lat: pudo.address.latitude, lng: pudo.address.longitude }}
                icon={podoPinIcon}
                popupMarker={OmParcelOrderModel.PudoPopupMarkerContent(pudo, handleSelectPudo)}
              />
            ))}
          </TcMap>
        </>
      )}
      {!showMap && <TcCoverLoading />}
    </>
  );
};

export default OrderSelectLockerListOnMapTab;
